<template>
    <div class="bill_addon clr">
        <standart title="Відпустка" key="vacation_addon"
                  v-bind:is_active_result=false
                  v-bind:is_active_problem=false>
            
            <template v-slot:after_title>
                
                <div class="pre_title winner">
                    Період відпустки
                </div>
                <b-row class="renage_times">
                    <b-col sm="3">
                        <label for="vac_text">період відпустки *</label>
                    </b-col>
                    
                    <b-col sm="9">
                        <date-picker @confirm="set_preamblua"
                                     @clear="set_preamblua"
                                     value-type="format" v-model="form.time_range" :lang="d_lang" range
                                     :first-day-of-week="1" :shortcuts="shortcuts" confirm></date-picker>
                        
                        <b-form-valid-feedback :state="can_format">
                            терміном на {{diff_days}} дні(в) в період з {{ form.time_range[0] | formatDate }} по {{
                                form.time_range[1] | formatDate }}
                        </b-form-valid-feedback>
                    
                    </b-col>
                </b-row>
            </template>
            
            <template v-slot:mem_preamblua>
                <b-row class="doc_title" id="vac_text">
                    <b-col sm="3">
                        <label for="vac_text">текст відпустки *</label>
                    </b-col>
                    
                    <b-col sm="9">
                        <b-form-textarea
                            id="textarea-state"
                            v-model="mem_preamblua"
                            v-bind:disabled="!can_format"
                            :state="can_format" rows="3"
                        >
                        
                        </b-form-textarea>
                        <b-form-invalid-feedback :state="can_format">
                            Спочатку оберіть інтервал дат
                        </b-form-invalid-feedback>
                    
                    </b-col>
                
                </b-row>
                
                <b-row class="doc_title" id="user" v-if="is_vac_start">
                    <b-col sm="3">
                        <label for="vac_text">Тимчасово виконуючий обов'язки</label>
                    </b-col>
                    <b-col sm="9">
                        <div class="u_list bg-info text-white" id="approve_list" v-if="!obj_to_null(vac_user)">
                            <div class="user_add">
                                <div class="add user" @click="add_user">
                                    <i title="" class="fa add_user fa-plus-square" data-type="delegate_users"></i>
                                    <span>Оберіть користувача</span>
                                </div>
                            </div>
                        </div>
                        <div class="user_to_fire bd-callout bd-callout-info " v-else>
                            <user_block v-if="obj_to_null(this.vac_user)"
                                        :key="vac_user.id"
                                        v-bind:can_del=true
                                        v-bind:del_triger="remove_vac_user"
                                        v-bind:user="vac_user">
                            </user_block>
                        </div>
                    
                    </b-col>
                </b-row>
            </template>
        </standart>
    </div>
</template>

<script>
import standart from '../standart.vue';
import user_block from "../../../../../../shared/user/user_block/user_block.vue";
import DatePicker from 'vue2-datepicker';


import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});

export default {
    name: "vacation",
    components: {
        standart,
        DatePicker,
        user_block
    },
    data() {
        return {
            template: 'Прошу надати мені частину щорічної відпустки на період з дд/мм/рр по дд/мм/рр. На період відпустки по робочих питаннях прохання звертатись до (_______________ПІБ в.о.), (__________посада), а в разі невідкладних питань  - на email ________________@imcagro.com.ua або робочий телефон.',
            vacation_uniq: 'vac_user_add',
            remove_vac_user: 'remove_vac',
            is_vac_start : false,
            vac_user: {},
            form: {
                time_range: [],
                user_vacation: 0,
            },
            time_range_start: [
                new Date(), new Date()
            ],
            
            shortcuts: [
                {
                    onClick: () => {
                        this.time_range_start
                    }
                }
            ],
        }
    },
    
    mounted() {
    
    },
    
    methods: {
        add_user() {
            EventBus.$emit('load_users_filter', {
                    uniq: this.vacation_uniq,
                    active: [],
                }
            );
        },
        set_preamblua() {
            if (this.can_format) {
                let start = new moment(this.form.time_range[0]);
                let end = new moment(this.form.time_range[1]);
                this.mem_preamblua = 'Прошу надати мені частину щорічної відпустки на період з ' + moment(String(this.form.time_range[0])).format('DD/MM/YYYY') + ' по ' + moment(String(this.form.time_range[1])).format('DD/MM/YYYY') + '. На період відпустки по робочих питаннях прохання звертатись до (_______________ПІБ в.о.), (__________посада), а в разі невідкладних питань  - на email ________________@imcagro.com.ua або робочий телефон.';
            }
            else
            {
                this.mem_preamblua = 'Прошу надати мені частину щорічної відпустки на період з дд/мм/рр по дд/мм/рр. На період відпустки по робочих питаннях прохання звертатись до (_______________ПІБ в.о.), (__________посада), а в разі невідкладних питань  - на email ________________@imcagro.com.ua або робочий телефон.';
            }
        },
    
    },
    
    computed: {
        ...mapFields([
            'active_memorandum'
        ]),
        
        
        can_format() {
            return this.form.time_range.length > 0 && this.form.time_range[0].length > 0 && this.form.time_range[1].length > 0;
        },
        
        diff_days() {
            if (this.can_format) {
                const start = new moment(this.form.time_range[0]);
                const end = new moment(this.form.time_range[1]);
                return moment.duration(end.diff(start)).asDays() + 1;
            }
        },
        
        d_lang() {
            return this.get_datepickLang();
        },
        
        
        active_mem () {
            return this.active_memorandum;
        },
        
        mem_preamblua : {
            get() {
                return this.active_mem.preamblua;
            },
            set (value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM',{preamblua : value});
            }
        },
        
        return_data : function () {
            return this.form;
        },
    },
    
}

</script>

<style scoped>
.pre_title.winner {
    margin-top: 40px;
    font-size: 25px;
    border-bottom: 1px solid #eee;
    margin-bottom: 15px;
}

.add.user {
    text-align: left;
    font-size: 22px;
    padding-left: 15px;
    color: white;
    cursor: pointer;
    margin-top: 20px;
}
</style>
